import { PagePending } from "@/components/ui/PagePending";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { fallback, number, object, optional, picklist, pipe, toMinValue } from "valibot";

export const Route = createFileRoute("/admin/surpluses")({
  pendingComponent: PagePending,
  component: lazyRouteComponent(() => import("./+SurplusesPage")),
  validateSearch: object({
    page: fallback(pipe(optional(number(), 1), toMinValue(1)), 1),
    "page-size": fallback(pipe(optional(number(), 100), toMinValue(10)), 100),
    status: fallback(
      optional(picklist(["unprocessed", "notified", "refunded", "invoiced", "reprocessed"]), "unprocessed"),
      "unprocessed",
    ),
  }),
  beforeLoad: () => ({
    breadcrumb: "Surpluses",
  }),
  head: () => ({
    meta: seo({ title: "Surpluses" }),
  }),
});
